import { baseApi } from '../apiProvider';
import { RequestBlock } from '../models/request/requestBlock';
import { ResponseBlock } from '../models/response/responseBlock';

const blockAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get list block
    getListBlock: builder.query<Array<ResponseBlock>, void>({
      query: () => ({
        url: `/v0/block`,
        method: 'GET',
      }),
    }),
    // block somebody
    addBlock: builder.mutation<ResponseBlock, RequestBlock>({
      query: (body: RequestBlock) => ({
        url: `/v0/block`,
        method: 'POST',
        body,
      }),
    }),
    // cancel or delete block
    deleteBlock: builder.mutation<any, string>({
      query: (id: string) => ({
        url: `/v0/block/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});
export const {
  useGetListBlockQuery,
  useAddBlockMutation,
  useDeleteBlockMutation,
} = blockAPI;
